
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as resetsrAt8RAlrOu64gdTgBak073rGkd6WMWuxMq5t7Tc3kEMeta } from "/frontend/pages/reset.vue?macro=true";
import { default as token4OHl2pxJuDp_4yiAVUEN8qkWY7Xwr1tJUH0r8rrPhN0Meta } from "/frontend/pages/token.vue?macro=true";
import { default as indexq3h1z2YKZe7C7OM5_45SwkT5Fgv5CUx4UwrD0wgdkjnN4Meta } from "/frontend/pages/portal/index.vue?macro=true";
import { default as DnqCtaaLRWhU_sF50oRfwzawVdi4R6G89P7vfDYvGipKF1jqoMeta } from "/frontend/pages/portal/DnqCta.vue?macro=true";
import { default as closingJqw7gXnC1XP6h9jfTIwQ5K4gSku9nMTLkj41ULivM4cMeta } from "/frontend/pages/portal/closing.vue?macro=true";
import { default as settingsDUKF_452zQB_453UUBy1Bee_45wCK3IhFRB_HrGed5fI2_45lO4Meta } from "/frontend/pages/portal/settings.vue?macro=true";
import { default as documentst9iZb1xzZ8LS6qQK7_oc9breL4_45qEBIyX4x_451l0cx0YMeta } from "/frontend/pages/portal/documents.vue?macro=true";
import { default as sunrise_45appb_45EB9fE2dX2Z48q4IOl2rQLQ5eFDQTWMzX6Xsm6vuy4Meta } from "/frontend/pages/portal/sunrise-app.vue?macro=true";
import { default as adjust_45offerXPLcmlwc_45kUPArPsYlBZJn__45BG5uB_91tKg8xYrRa6cMeta } from "/frontend/pages/portal/adjust-offer.vue?macro=true";
import { default as credit_45cardsaO5VsZErOJrIoK1AanrflsUsQlAhcD4CbcIo9jSlS5oMeta } from "/frontend/pages/portal/credit-cards.vue?macro=true";
import { default as indexy5KG89u40sGSJ9FdrczxngKmmjDxoJ_45Qi9Fp2bg_45YKUMeta } from "/frontend/pages/portal/offers/index.vue?macro=true";
import { default as indexxJT2S_45D34h_45GiZhmX28mFQ8ZSH7kIeOBp918m03NplgMeta } from "/frontend/pages/portal/options/index.vue?macro=true";
import { default as indexIz_YJbE3FsJyGi7clAQgwB9kfq28YtFR3GZ0rnMVuUcMeta } from "/frontend/pages/portal/loan-offers/index.vue?macro=true";
import { default as _91optionId_93P4irbobPPqYlUUBT4QuHrZwldvDDVtsgKNmh1lOoohAMeta } from "/frontend/pages/portal/offers/[optionId].vue?macro=true";
import { default as business_45resources2qX3alk8CHiZirGC8I32L98vdnnB4YZVDdLp_KChMh0Meta } from "/frontend/pages/portal/business-resources.vue?macro=true";
import { default as _91optionId_93WInD97KGWv1DiQe17tx_457a51R09ST_fmwQjhYcWJ2DcMeta } from "/frontend/pages/portal/options/[optionId].vue?macro=true";
import { default as offers_452_45confirmationy83VId7OEYXc4E7Jo_45olh6oDiQDnUo9SI0iZey3g5B4Meta } from "/frontend/pages/portal/offers-2-confirmation.vue?macro=true";
import { default as explore_45other_45productsBFBdwts8zxclwmLemmbb0FL27AwxBI862xTtKNqGMgwMeta } from "/frontend/pages/portal/explore-other-products.vue?macro=true";
import { default as _91optionId_93f9LGXdkyXA51RLjNJ7j19QVuzDceOHediM6HVZ5RUNwMeta } from "/frontend/pages/portal/loan-offers/[optionId].vue?macro=true";
import { default as portalbQ2yB_45USRXML4B6vuojYIBhK1ELqnYQGPKGffHtkg3gMeta } from "/frontend/pages/portal.vue?macro=true";
import { default as submitAg6GBJZPX_aFO_45J66LPPl4amBaVj4fJXHkiL46E3FasMeta } from "/frontend/pages/submit.vue?macro=true";
import { default as newpass_45g8xTdBqJLRt0QjpEwhO4ABI79bV73TEaBtNZCyRPAgMeta } from "/frontend/pages/newpass.vue?macro=true";
import { default as rollbarLT8XpSjXYkvOKLTPsXuXCPL_45jj4nz2eYnSYvpdnTNfMMeta } from "/frontend/pages/rollbar.vue?macro=true";
import { default as sync9fFuZTlGNAgkE7OIQzQA8dvOoDBtoJgmlfLCB5TIp3wMeta } from "/frontend/pages/documents/sync.vue?macro=true";
import { default as indexxWmV9ibQU0A_FdXQJ3VlKN1FtR3_45DVJtTx9Snid_aiAMeta } from "/frontend/pages/documents/index.vue?macro=true";
import { default as manualTBirJ9qR4_pX_BZnS6dxQMwtThvJcKzgJCquewEavikMeta } from "/frontend/pages/documents/manual.vue?macro=true";
import { default as resultsufGH7bF0LnWXottzOZ7PAWl_45sdQLqqqmMTfTXGIQKowMeta } from "/frontend/pages/documents/results.vue?macro=true";
import { default as accountshkDzDuJ1e5Pt2L80HdD5Px1u3D9_4584NWZ3mPGw4J_457oMeta } from "/frontend/pages/documents/accounts.vue?macro=true";
import { default as sync_45errorS_npWCU5K0VM8QcI3KF0M2f_22uXMBCh_45gcHGbzthaMMeta } from "/frontend/pages/documents/sync-error.vue?macro=true";
import { default as statement_45errorrAwStlzSHXN7cg889am_a02altEMRhsHcTA93N79NoMMeta } from "/frontend/pages/documents/statement-error.vue?macro=true";
import { default as documentsQrrpIJSi4MBwLA0qNSUP82_e7Xk89YFQ6BH7vAxt18YMeta } from "/frontend/pages/documents.vue?macro=true";
import { default as basic_45infoneKJOvgV7OpMVyogUId_45FpRZcSWHB8RD59vCIFLYwVYMeta } from "/frontend/pages/basic-info.vue?macro=true";
import { default as indexTYcS0KqPyu_45QfOxMtV7omcGXGqxAs3CoJpHadoSO3iIMeta } from "/frontend/pages/next-steps/index.vue?macro=true";
import { default as chat_45nowurKh8xUXiuseUIYuVj1if63SotkUyh5yQW1eUaWUF3cMeta } from "/frontend/pages/next-steps/chat-now.vue?macro=true";
import { default as great_45newsRkGlmTOKymId_rJAVHNtkcq3p5_45RavGXiJ_45Z0PDUbWEMeta } from "/frontend/pages/next-steps/great-news.vue?macro=true";
import { default as book_45a_45callftiIawpTYpRmRDFi5EVKpzBr23Dwld5vzJpGzu5w7toMeta } from "/frontend/pages/next-steps/book-a-call.vue?macro=true";
import { default as rest_45assured_aBtyS5ZSaC1Bdjc7KgtCGc0koUKqtgPsOMnRCYYdg4Meta } from "/frontend/pages/next-steps/rest-assured.vue?macro=true";
import { default as funding_45expertOEGcK_gds9m7P_rS40yabkp82OHOfO_tBl5W0x0efTIMeta } from "/frontend/pages/next-steps/funding-expert.vue?macro=true";
import { default as what_45comes_45nextWhnmHoDNT4552HFTWpaUOy2yoHlcwSF_mCpgXzuAaSUMeta } from "/frontend/pages/next-steps/what-comes-next.vue?macro=true";
import { default as next_45stepsdhBreauer84SQlDzA14_driYNuJysj2UicbakulJVSUMeta } from "/frontend/pages/next-steps.vue?macro=true";
import { default as indexMkuEqFzZ_Dneco9iF6uaT9dVuvr7DSl9S58F1edS2MEMeta } from "/frontend/pages/owner-info/index.vue?macro=true";
import { default as owner_45info_452t0d6DctW10Z36TguO453eybyhfqm10qvqcE1rd_NunAMeta } from "/frontend/pages/owner-info/owner-info-2.vue?macro=true";
import { default as owner_45info_453qHICeLdqf7Bj2RS_45IaJrlwZa39BkhxZpliS9GNb2jFIMeta } from "/frontend/pages/owner-info/owner-info-3.vue?macro=true";
import { default as owner_45info_454Ra5IZ21TzD3Iekou4HQA9x5gaVJsxPy9XFmCA74torcMeta } from "/frontend/pages/owner-info/owner-info-4.vue?macro=true";
import { default as owner_45infovfJDUbRVlJvteaorYMuQb8j0zQFZCmdehVs1Okmhb0MMeta } from "/frontend/pages/owner-info.vue?macro=true";
import { default as playgroundRzADiIb9u21bDw1QdqFRSKg61WcGesGB5MvpmKXaOYgMeta } from "/frontend/pages/playground.vue?macro=true";
import { default as resume_45app3WeL6_45R977rvYa6rv228EYJimw0Abgo_45RPHYvbav9qwMeta } from "/frontend/pages/resume-app.vue?macro=true";
import { default as waypoint_450KCEiR0JV1gPMSXmyDdbmtyPE_45acKeqS9dl7bQ_0u8H0Meta } from "/frontend/pages/waypoint-0.vue?macro=true";
import { default as waypoint_451U9ucGsmoCchXKFaIKcU6OB_uWJdtL6tl2gQLpFWKApcMeta } from "/frontend/pages/waypoint-1.vue?macro=true";
import { default as cookie_45testyh9sIaDnoUVN4GPs2_45f4r5LZ38AVbaGmfgy5rK0dsUgMeta } from "/frontend/pages/cookie-test.vue?macro=true";
import { default as healthcheckYQ8eo1fMo7prZ5ymNyJxt_wOdqKc85lsGcGdG4lNYNcMeta } from "/frontend/pages/healthcheck.vue?macro=true";
import { default as login_45errorywEx_45Wectovy61ydcmvxbJe2h13k2U5pUl6qTKwMq6IMeta } from "/frontend/pages/login-error.vue?macro=true";
import { default as multiselectiYZpEooNeBcEskBovEAZrMQsVQUaP_45booMk0XyYU8VsMeta } from "/frontend/pages/multiselect.vue?macro=true";
import { default as heloc_45optiontYr1MajY5lmQUHYs_dTDmpJbWyXmcYrXqt5NOW9J4PwMeta } from "/frontend/pages/heloc-option.vue?macro=true";
import { default as under_45reviewX1vnZZUugn_Jqjx9ZbBszgUBATZ54myq5RYsuwAcqdUMeta } from "/frontend/pages/under-review.vue?macro=true";
import { default as index_mEV_45Xcs3qrBsFmPl_45sTn7LiLmsJ72MsCUNna8pT4WIMeta } from "/frontend/pages/updated-info/index.vue?macro=true";
import { default as updated_45infooP5phe2d7oXgGEjSgu9FeVHdWi_45L8MCxARgS86xA81MMeta } from "/frontend/pages/updated-info.vue?macro=true";
import { default as indexlGpYXktsZRgC0KKmncZ3i4vol2EHPCh2z0ULS64xxqMMeta } from "/frontend/pages/upload/index.vue?macro=true";
import { default as indexQQOgBfa0k5tmB8HAJsEgGdkTRf1icr0J4_pFDVkglxoMeta } from "/frontend/pages/business-info/index.vue?macro=true";
import { default as business_45info_452k32xGOtCRIHiiPlUoTLvAT3ZcElNRUibjt_45qx0JdryQMeta } from "/frontend/pages/business-info/business-info-2.vue?macro=true";
import { default as business_45info_453UZTY9_mHSqpp_45VbbuVg0P85B41wn88O6f5F07RyKtQMMeta } from "/frontend/pages/business-info/business-info-3.vue?macro=true";
import { default as business_45infobAMqXNIzhfTMl1fTVys2h_x8nFUpRQ_45LQx2fQjD6vK8Meta } from "/frontend/pages/business-info.vue?macro=true";
import { default as indexrqnHW0yOU_457uvpQ7M_45aIzAifYnDtXNiu800Op2hJHMoMeta } from "/frontend/pages/renewal/index.vue?macro=true";
import { default as manualijbd5TXS_45NnhYZE5eKvwj7ktIELIiU0XH75GhN6pikMMeta } from "/frontend/pages/upload/manual.vue?macro=true";
import { default as indexOOU7MfCzXPxQiH8lz7NBlSbK0mSNI5Fltp7bXSqO9XcMeta } from "/frontend/pages/basic-info-new/index.vue?macro=true";
import { default as _questionkFAPoCeg30Qwbmsf_453AcjdGjIEuRF2Hw9CPbZkb63okMeta } from "/frontend/pages/basic-info-new/_question.vue?macro=true";
import { default as basic_45info_45newCRPiaJc8hZRScMbKNnacpaVRAhZSdf2nEEwL7GvJIQ8Meta } from "/frontend/pages/basic-info-new.vue?macro=true";
import { default as index4I7Xz_45D8zqxmujKwPVmZ7ETZUna_vF2DIz5xuutjSg8Meta } from "/frontend/pages/embedded/index.vue?macro=true";
import { default as indexm65eO2jflY0sicSPHN9nOTgPVsDfSA49ZfsDRowFJYgMeta } from "/frontend/pages/identity/index.vue?macro=true";
import { default as submitm0JgYN6OmbMWsyY5fG0Qyt_cHVQZPPWzFJ1v7VYMj8cMeta } from "/frontend/pages/renewal/submit.vue?macro=true";
import { default as syncUCrnhWFJXE_45rL1Ip1EXfXeaBcNzZMrB4FGAHSK3nPJQMeta } from "/frontend/pages/embedded/portal/sync.vue?macro=true";
import { default as index5tUHtevgpkNDnWyTNWFLgU5iDflJWYIU17wPQGKS2l8Meta } from "/frontend/pages/embedded/portal/index.vue?macro=true";
import { default as resultsq1FbclEOUw9bXddFir_45yvym2uhHTfnHpGFJTWdWHDsAMeta } from "/frontend/pages/embedded/portal/results.vue?macro=true";
import { default as accountsviMzRUV3MrZRdeNJBJa7hsQj_hUfKs6jZ1TuHc20b38Meta } from "/frontend/pages/embedded/portal/accounts.vue?macro=true";
import { default as dashboardjsLH_xn6jigKJ8fv3P92p0JACcIGudTuWfE_45qU94hJcMeta } from "/frontend/pages/embedded/portal/dashboard.vue?macro=true";
import { default as documentsgzy_oAoWG2_f8Gd3w4_TKaOancIoUBvhCGCV5flMCNMMeta } from "/frontend/pages/embedded/portal/documents.vue?macro=true";
import { default as sync_45errorfCqbjdr92kDhw0cHMgLqGPXc6CHFjKZNSHEFjzbkzV0Meta } from "/frontend/pages/embedded/portal/sync-error.vue?macro=true";
import { default as statement_45error57lwPuosHOtkZn0NtJKFJgthA2JMJ_HQAqQqMwT_459DMMeta } from "/frontend/pages/embedded/portal/statement-error.vue?macro=true";
import { default as _91optionId_93oZmSAm8LiomwNPLM8HC6Tuw8Dc5dAk48PzAezLYRXykMeta } from "/frontend/pages/embedded/portal/options/[optionId].vue?macro=true";
import { default as portalWete5wHUFO3fpdmya0DGomNS3tLTHHPfMbnllH9XehMMeta } from "/frontend/pages/embedded/portal.vue?macro=true";
import { default as submitzHiRNnOzmCNa0dY_tzpZFFfnuWw6HcWbAtlI9eyjdrsMeta } from "/frontend/pages/embedded/submit.vue?macro=true";
import { default as bad_45token5rdn9LwCt_45ZISZiJarknZrdUW4hqgT9RHcesivTEVwcMeta } from "/frontend/pages/guest/bad-token.vue?macro=true";
import { default as tax_45returnsuQV_vSa2k1rBI7gPixkxdK6ClOFjJuICVZTLZjO2VMIMeta } from "/frontend/pages/sba/tax-returns.vue?macro=true";
import { default as finicity3NcUMFEyUFqtU_45CkjC6ZuAiGPC_45J9Num3eKLbQg_45f2sMeta } from "/frontend/pages/upload/finicity.vue?macro=true";
import { default as requestsnumWZrs_p8ID866qeZ9JsF21yftcjuDWzTw23wPuR0IMeta } from "/frontend/pages/upload/requests.vue?macro=true";
import { default as balance_45sheetssfD_9yid2Se7xBE1bYNWLx20zd0dSoQ_45fND_v_45piY4Meta } from "/frontend/pages/sba/balance-sheet.vue?macro=true";
import { default as debt_45scheduleuELk_PIj7MsdVRITsa_45c_45YRO9odk56TvpHQ5gy6pd6gMeta } from "/frontend/pages/sba/debt-schedule.vue?macro=true";
import { default as credit_45card_45widgetjugnDK4_453ljatQwB7Tc8W5POnOdaY_I3mkGU_5WtLsYMeta } from "/frontend/pages/credit-card-widget.vue?macro=true";
import { default as synchJwJHST1TUaFqTagsED0re7wPLINpik4_45b4xn46dmq8Meta } from "/frontend/pages/embedded/documents/sync.vue?macro=true";
import { default as indexcD445DTW9YYXw70vQM2OL_45utEyeY_45SBCm5O1JmUGjqQMeta } from "/frontend/pages/embedded/documents/index.vue?macro=true";
import { default as manual7HOzq3cLpyn_45Zedl5yzdfN3bnhuN4MU3oTzILzRxwe0Meta } from "/frontend/pages/embedded/documents/manual.vue?macro=true";
import { default as resultsoaDTH2Lf5CSPqht2AJkbRmpw5Rneki_456FzcJTJv9UZAMeta } from "/frontend/pages/embedded/documents/results.vue?macro=true";
import { default as accountsRDvD4RPSCr8jWcouDHefVykMxNepwqXobYMbx1AfwK4Meta } from "/frontend/pages/embedded/documents/accounts.vue?macro=true";
import { default as sync_45errorHqa9VOanZiLpJuKDxNOVgIgwaxwvOEVZm6AE3XmYTjIMeta } from "/frontend/pages/embedded/documents/sync-error.vue?macro=true";
import { default as statement_45errorlwILvFOhpO8mgFj5HcIoligFvRykXeDNTtwE_45O8sGRkMeta } from "/frontend/pages/embedded/documents/statement-error.vue?macro=true";
import { default as documents1WkmfaNAVpXwtwE903P6yptT6VobyqhPtZiWv9FihvIMeta } from "/frontend/pages/embedded/documents.vue?macro=true";
import { default as indexXmAxiRTZJwBadAkVW6SnJ_452X7zWLDnjiPzTzWarV_BIMeta } from "/frontend/pages/sba-complete/index.vue?macro=true";
import { default as resume_45appZgdNXJ5t6AmRniERr1Y3WZuVtRql3Bmemu756zhKHYYMeta } from "/frontend/pages/embedded/resume-app.vue?macro=true";
import { default as indexxrEiTOHYVhq_6wAOx_45ElKdFIuJTMJ43bf8ul2T4ruS0Meta } from "/frontend/pages/funding-needs/index.vue?macro=true";
import { default as profit_45and_45lossgEDfcgfgf9_45P62J_SO6VS9FQyfv_45E1KtWxWrUVBLLiMMeta } from "/frontend/pages/sba/profit-and-loss.vue?macro=true";
import { default as app_45complete_45landingCE4H7t8WemuUjZ0o5B8UHCvKeN7CwmkjeF16MKJuP68Meta } from "/frontend/pages/app-complete-landing.vue?macro=true";
import { default as _91component_93GgQVhfAEH7Yk6AisKJf7YsUZhR5bqTWc24V1tHl3ORUMeta } from "/frontend/pages/identity/[component].vue?macro=true";
import { default as redirect_45from_45lendioZcNhsifIBKsDwB0NEtmYXeH_zIEgZaqZwVsfWSuj6TMMeta } from "/frontend/pages/redirect-from-lendio.vue?macro=true";
import { default as advertiser_45disclosuregvoDuUZLc0orHY6Tj7OA5c7cadWJMhnZffpdl6Od_45dkMeta } from "/frontend/pages/advertiser-disclosure.vue?macro=true";
import { default as business_45infoaS3n8iQDbaQqwYZxwYlHe6ufY747mzrFz_jdecsRdVUMeta } from "/frontend/pages/renewal/business-info.vue?macro=true";
import { default as indexm2VUoDmgorzWOrEC3jFo6RNWsVahEbQDUcUe2fN4fZQMeta } from "/frontend/pages/[identifier]-app/index.vue?macro=true";
import { default as indexf74NMKswyG2liR_7RWe0f1VMWENO9Z2f_45J_45tKBnmt2cMeta } from "/frontend/pages/renewal/documents/index.vue?macro=true";
import { default as manualckDQlayw_TkpIGosh11XfPy94d5pTGt1azA3_45VU21aUMeta } from "/frontend/pages/renewal/documents/manual.vue?macro=true";
import { default as debt_45schedule_45uploadoUZDAZP0i4j0tf_3wJp4dQ9sG0Z75BYXAezWBahqFvEMeta } from "/frontend/pages/sba/debt-schedule-upload.vue?macro=true";
import { default as _91_91slug_93_93xqO3Du7v7S2nuqxXR0wRw8Fr9IgjyBxlsdP_458knq848Meta } from "/frontend/pages/[identifier]-app/[[slug]].vue?macro=true";
import { default as indexRhn9u_yrzTFVb5OkVPFTCgiFtXGy8RJXbcjEmKfxfxsMeta } from "/frontend/pages/intelligent-lending/index.vue?macro=true";
import { default as indexGfPncHXPKwssAmJzzS3iEQXS_S4O5kYdve17A1Jcz68Meta } from "/frontend/pages/sba-complete/portal/index.vue?macro=true";
import { default as indexpIgEH_45FHjgkGzpPKcLggWogofruO864zvfCvnDCobp8Meta } from "/frontend/pages/intelligent-lending/portal/index.vue?macro=true";
import { default as dashboardXgPc7JSFTNiz6LMPJXCUQ9vkuWNjlDx_CNIVjC9yrOsMeta } from "/frontend/pages/intelligent-lending/portal/dashboard.vue?macro=true";
import { default as documents4Fs_45DIZ8Bd8CMwaGOVZPeCHCM9POAj5qDDwM2Ar4MwsMeta } from "/frontend/pages/intelligent-lending/portal/documents.vue?macro=true";
import { default as _91optionId_93qxaMaz9O55pCcC7RdDE4StCNYMtyfig3xS2DX9wBwegMeta } from "/frontend/pages/intelligent-lending/portal/options/[optionId].vue?macro=true";
import { default as portal1DyOuxZ4iUzdcxGUM_ztsa6HqRAjhL22Ik7qjCOT1LMMeta } from "/frontend/pages/intelligent-lending/portal.vue?macro=true";
import { default as indexmoCHtu7EVEVx30oet2PmzdIOiDoBRTDgqxm6xOdmMlwMeta } from "/frontend/pages/renewal/credit-check/index.vue?macro=true";
import { default as reviewhn1NZp0DVD_p3inlF9c2KdNd_45vHP9QrvgV88BEGtB30Meta } from "/frontend/pages/renewal/credit-check/review.vue?macro=true";
import { default as index21fxnIBIXWZslO_45dfbSqzAeJlKfeXluDiMMjGgQ96QkMeta } from "/frontend/pages/guest/additional-owner/index.vue?macro=true";
import { default as new_45loan_45requirementsg92mo0DE7_47jKHbiTFFhpwnKbYzigqRXLJ4s8gtMmwMeta } from "/frontend/pages/renewal/new-loan-requirements.vue?macro=true";
import { default as documentsnhEgr7Ue_45ldgcoDVW6YrcRoWQ9eCKDBInAv9MdOWcBEMeta } from "/frontend/pages/sba-complete/portal/documents.vue?macro=true";
import { default as indexLRxjBd5Gv2faJGU0f67UHeWqE5A8GFkOLRrY_YuM_45YIMeta } from "/frontend/pages/embedded/[identifier]-app/index.vue?macro=true";
import { default as _91_91moduleIdentifier_93_93VA9i4xuXPSVJ3NDnibHdU3u4gNRMZBFH7iw5crnjD2QMeta } from "/frontend/pages/application/[[moduleIdentifier]].vue?macro=true";
import { default as _91authType_93jQqxlLujyMmIPuW1YgqP8us1sV5qcjBJCkuW2iaubMYMeta } from "/frontend/pages/document-upload-request/[authType].vue?macro=true";
import { default as _91_91slug_93_93e4hab0weHUOjGVa40_45foByVrCAyTUjx_l9uywzHuKvkMeta } from "/frontend/pages/embedded/[identifier]-app/[[slug]].vue?macro=true";
import { default as post_45offer_45docscvswxhwYCGH0UcWZWclmsjkNl1fUncJMKw1Rp6lY5jsMeta } from "/frontend/pages/guest/additional-owner/post-offer-docs.vue?macro=true";
import { default as _91authType_93YUsLfn2aQMM2me8ti9Qaj9uBy1PLcILPBPnwhvtHctoMeta } from "/frontend/pages/embedded/document-upload-request/[authType].vue?macro=true";
import { default as indexY_KWRMLPxuopwYEFVmt74OGdxaBcccnrkq8fPzMNzgsMeta } from "/frontend/pages/document-upload-request/invite-expired/index.vue?macro=true";
import { default as indexJhK3HqYQB8RFnu9bMa_thV32UcQ7uAyoFzUDA99avXoMeta } from "/frontend/pages/embedded/document-upload-request/invite-expired/index.vue?macro=true";
import { default as basic_45infowNHn_450Pa7TqG_3t2zL5tUc1i9qgM9Ob9VhBzN9BF3DgMeta } from "~/pages/basic-info.vue?macro=true";
import { default as indexK64C_45O2mp4GqPo3E4O1hTQG0wpwozxGgfZjA345GDD0Meta } from "~/pages/owner-info/index.vue?macro=true";
import { default as owner_45info_452yz2cMWLJbp6fvZY254WruVkFPOVTu2wemo7KQX9rfHMMeta } from "~/pages/owner-info/owner-info-2.vue?macro=true";
import { default as owner_45info_453T3TfkhNxxLejrxU9LrqVRKxcRYWkqrEh74TCU8RzXF0Meta } from "~/pages/owner-info/owner-info-3.vue?macro=true";
import { default as owner_45infon2CGFN5bZlpexaQz005VuiL2_45aIznDSiaTh9q1lYAvQMeta } from "~/pages/owner-info.vue?macro=true";
import { default as indexKoNmPaOPj9fO_45AVi0r0_45pjw3cnfJWWSOSUkdKUzO6NEMeta } from "~/pages/business-info/index.vue?macro=true";
import { default as business_45info_4527psyUxUEEuQINe7f9FVNH04FkFLIdOOWutgaU_gfDqQMeta } from "~/pages/business-info/business-info-2.vue?macro=true";
import { default as business_45info_453MdB7j_hMLF_45rxUJ2sp99_45oMHfi5zq0ukMuYIv7QuCfoMeta } from "~/pages/business-info/business-info-3.vue?macro=true";
import { default as business_45infoXDsz_45sSqy_4590EqfoL0D_5bql_45vaAec2h0mhCSkrQdIQMeta } from "~/pages/business-info.vue?macro=true";
import { default as indexZ9aaVvuzpxfqSYY4hXdaXn8HVfLGTrDcS6Z5GMvx9_UMeta } from "~/pages/documents/index.vue?macro=true";
import { default as accountsuBSOEx81DpVW9rl_RsyWufEG_45t2wq643omUIpaTDz7UMeta } from "~/pages/documents/accounts.vue?macro=true";
import { default as manualFfdgWJZy1iB7VC1BzIgiRv9u3Td128FsrfAYWJN_45VEEMeta } from "~/pages/documents/manual.vue?macro=true";
import { default as resultsaPXJgf4mfFB8p9abOVmX1yxGTtaqRqa4ENu1qdY0nkoMeta } from "~/pages/documents/results.vue?macro=true";
import { default as statement_45errorzP33rheL2DsxelLd0YM_45V4YgsqbeAsD3DZC4gC9OBe8Meta } from "~/pages/documents/statement-error.vue?macro=true";
import { default as sync_45errorx_45VB5eaPM3SqV5sqPrckOPF0h1NQ9AcdgqnEwVnQo9oMeta } from "~/pages/documents/sync-error.vue?macro=true";
import { default as syncpxmBItkpUdp2ZTELUumD_Wax5yb5tI57CyYKetoSaQcMeta } from "~/pages/documents/sync.vue?macro=true";
import { default as documents7_DYPq8779fTX9Gn6aG9g5SzaBW_45x1PyD1UW_45Fcr_aYMeta } from "~/pages/documents.vue?macro=true";
import { default as tax_45returns_45uBs0vuVn41C_xAe4hZXYXxRuIBwLINWylfg_450npgiIMeta } from "~/pages/sba/tax-returns.vue?macro=true";
import { default as debt_45scheduleM5qmco6kmOe6xwg7lTdi4LNQ1zGYRA6OVC5_dcv3aq4Meta } from "~/pages/sba/debt-schedule.vue?macro=true";
import { default as debt_45schedule_45uploadN03F58eiN8Tz9nEWThiuRD7g7zJzO5Lm711cwskCDCIMeta } from "~/pages/sba/debt-schedule-upload.vue?macro=true";
import { default as profit_45and_45lossmpiDu4cis9pJC87J55i7ipfGZIV0hkrVfoFBLRWPnDwMeta } from "~/pages/sba/profit-and-loss.vue?macro=true";
import { default as balance_45sheetU4IaDaZIQKNlnBfUXmSbLdb2GPwsr6q50MMEm7xlqVIMeta } from "~/pages/sba/balance-sheet.vue?macro=true";
import { default as submitFLwjJ08Bcd41JWktkSWQjUpOoWjBAK8XJ_LyBPW3YJMMeta } from "~/pages/embedded/submit.vue?macro=true";
export default [
  {
    name: "reset",
    path: "/reset",
    meta: resetsrAt8RAlrOu64gdTgBak073rGkd6WMWuxMq5t7Tc3kEMeta || {},
    component: () => import("/frontend/pages/reset.vue")
  },
  {
    name: "token",
    path: "/token",
    meta: token4OHl2pxJuDp_4yiAVUEN8qkWY7Xwr1tJUH0r8rrPhN0Meta || {},
    component: () => import("/frontend/pages/token.vue")
  },
  {
    name: portalbQ2yB_45USRXML4B6vuojYIBhK1ELqnYQGPKGffHtkg3gMeta?.name,
    path: "/portal",
    meta: portalbQ2yB_45USRXML4B6vuojYIBhK1ELqnYQGPKGffHtkg3gMeta || {},
    component: () => import("/frontend/pages/portal.vue"),
    children: [
  {
    name: "portal",
    path: "",
    component: () => import("/frontend/pages/portal/index.vue")
  },
  {
    name: "portal-DnqCta",
    path: "DnqCta",
    component: () => import("/frontend/pages/portal/DnqCta.vue")
  },
  {
    name: "portal-closing",
    path: "closing",
    component: () => import("/frontend/pages/portal/closing.vue")
  },
  {
    name: "portal-settings",
    path: "settings",
    component: () => import("/frontend/pages/portal/settings.vue")
  },
  {
    name: "portal-documents",
    path: "documents",
    component: () => import("/frontend/pages/portal/documents.vue")
  },
  {
    name: "portal-sunrise-app",
    path: "sunrise-app",
    component: () => import("/frontend/pages/portal/sunrise-app.vue")
  },
  {
    name: "Offers",
    path: "adjust-offer",
    meta: adjust_45offerXPLcmlwc_45kUPArPsYlBZJn__45BG5uB_91tKg8xYrRa6cMeta || {},
    component: () => import("/frontend/pages/portal/adjust-offer.vue")
  },
  {
    name: "portal-credit-cards",
    path: "credit-cards",
    component: () => import("/frontend/pages/portal/credit-cards.vue")
  },
  {
    name: "Offers",
    path: "offers",
    meta: indexy5KG89u40sGSJ9FdrczxngKmmjDxoJ_45Qi9Fp2bg_45YKUMeta || {},
    component: () => import("/frontend/pages/portal/offers/index.vue")
  },
  {
    name: "portal-options",
    path: "options",
    component: () => import("/frontend/pages/portal/options/index.vue")
  },
  {
    name: "portal-loan-offers",
    path: "loan-offers",
    meta: indexIz_YJbE3FsJyGi7clAQgwB9kfq28YtFR3GZ0rnMVuUcMeta || {},
    component: () => import("/frontend/pages/portal/loan-offers/index.vue")
  },
  {
    name: "portal-offers-optionId",
    path: "offers/:optionId()",
    meta: _91optionId_93P4irbobPPqYlUUBT4QuHrZwldvDDVtsgKNmh1lOoohAMeta || {},
    component: () => import("/frontend/pages/portal/offers/[optionId].vue")
  },
  {
    name: "portal-business-resources",
    path: "business-resources",
    component: () => import("/frontend/pages/portal/business-resources.vue")
  },
  {
    name: "portal-options-optionId",
    path: "options/:optionId()",
    component: () => import("/frontend/pages/portal/options/[optionId].vue")
  },
  {
    name: "portal-offers-2-confirmation",
    path: "offers-2-confirmation",
    component: () => import("/frontend/pages/portal/offers-2-confirmation.vue")
  },
  {
    name: "portal-explore-other-products",
    path: "explore-other-products",
    meta: explore_45other_45productsBFBdwts8zxclwmLemmbb0FL27AwxBI862xTtKNqGMgwMeta || {},
    component: () => import("/frontend/pages/portal/explore-other-products.vue")
  },
  {
    name: "portal-loan-offers-optionId",
    path: "loan-offers/:optionId()",
    meta: _91optionId_93f9LGXdkyXA51RLjNJ7j19QVuzDceOHediM6HVZ5RUNwMeta || {},
    component: () => import("/frontend/pages/portal/loan-offers/[optionId].vue")
  }
]
  },
  {
    name: "submit",
    path: "/submit",
    meta: submitAg6GBJZPX_aFO_45J66LPPl4amBaVj4fJXHkiL46E3FasMeta || {},
    component: () => import("/frontend/pages/submit.vue")
  },
  {
    name: "newpass",
    path: "/newpass",
    meta: newpass_45g8xTdBqJLRt0QjpEwhO4ABI79bV73TEaBtNZCyRPAgMeta || {},
    component: () => import("/frontend/pages/newpass.vue")
  },
  {
    name: "rollbar",
    path: "/rollbar",
    component: () => import("/frontend/pages/rollbar.vue")
  },
  {
    name: documentsQrrpIJSi4MBwLA0qNSUP82_e7Xk89YFQ6BH7vAxt18YMeta?.name,
    path: "/documents",
    meta: documentsQrrpIJSi4MBwLA0qNSUP82_e7Xk89YFQ6BH7vAxt18YMeta || {},
    component: () => import("/frontend/pages/documents.vue"),
    children: [
  {
    name: "documents-sync",
    path: "sync",
    meta: sync9fFuZTlGNAgkE7OIQzQA8dvOoDBtoJgmlfLCB5TIp3wMeta || {},
    component: () => import("/frontend/pages/documents/sync.vue")
  },
  {
    name: "documents",
    path: "",
    meta: indexxWmV9ibQU0A_FdXQJ3VlKN1FtR3_45DVJtTx9Snid_aiAMeta || {},
    component: () => import("/frontend/pages/documents/index.vue")
  },
  {
    name: "documents-manual",
    path: "manual",
    component: () => import("/frontend/pages/documents/manual.vue")
  },
  {
    name: "documents-results",
    path: "results",
    meta: resultsufGH7bF0LnWXottzOZ7PAWl_45sdQLqqqmMTfTXGIQKowMeta || {},
    component: () => import("/frontend/pages/documents/results.vue")
  },
  {
    name: "documents-accounts",
    path: "accounts",
    meta: accountshkDzDuJ1e5Pt2L80HdD5Px1u3D9_4584NWZ3mPGw4J_457oMeta || {},
    component: () => import("/frontend/pages/documents/accounts.vue")
  },
  {
    name: "documents-sync-error",
    path: "sync-error",
    meta: sync_45errorS_npWCU5K0VM8QcI3KF0M2f_22uXMBCh_45gcHGbzthaMMeta || {},
    component: () => import("/frontend/pages/documents/sync-error.vue")
  },
  {
    name: "documents-statement-error",
    path: "statement-error",
    meta: statement_45errorrAwStlzSHXN7cg889am_a02altEMRhsHcTA93N79NoMMeta || {},
    component: () => import("/frontend/pages/documents/statement-error.vue")
  }
]
  },
  {
    name: "basic-info",
    path: "/basic-info",
    meta: basic_45infoneKJOvgV7OpMVyogUId_45FpRZcSWHB8RD59vCIFLYwVYMeta || {},
    component: () => import("/frontend/pages/basic-info.vue")
  },
  {
    name: next_45stepsdhBreauer84SQlDzA14_driYNuJysj2UicbakulJVSUMeta?.name,
    path: "/next-steps",
    meta: next_45stepsdhBreauer84SQlDzA14_driYNuJysj2UicbakulJVSUMeta || {},
    component: () => import("/frontend/pages/next-steps.vue"),
    children: [
  {
    name: "next-steps",
    path: "",
    meta: indexTYcS0KqPyu_45QfOxMtV7omcGXGqxAs3CoJpHadoSO3iIMeta || {},
    component: () => import("/frontend/pages/next-steps/index.vue")
  },
  {
    name: "next-steps-chat-now",
    path: "chat-now",
    component: () => import("/frontend/pages/next-steps/chat-now.vue")
  },
  {
    name: "next-steps-great-news",
    path: "great-news",
    meta: great_45newsRkGlmTOKymId_rJAVHNtkcq3p5_45RavGXiJ_45Z0PDUbWEMeta || {},
    component: () => import("/frontend/pages/next-steps/great-news.vue")
  },
  {
    name: "next-steps-book-a-call",
    path: "book-a-call",
    component: () => import("/frontend/pages/next-steps/book-a-call.vue")
  },
  {
    name: "next-steps-rest-assured",
    path: "rest-assured",
    meta: rest_45assured_aBtyS5ZSaC1Bdjc7KgtCGc0koUKqtgPsOMnRCYYdg4Meta || {},
    component: () => import("/frontend/pages/next-steps/rest-assured.vue")
  },
  {
    name: "next-steps-funding-expert",
    path: "funding-expert",
    component: () => import("/frontend/pages/next-steps/funding-expert.vue")
  },
  {
    name: "next-steps-what-comes-next",
    path: "what-comes-next",
    component: () => import("/frontend/pages/next-steps/what-comes-next.vue")
  }
]
  },
  {
    name: owner_45infovfJDUbRVlJvteaorYMuQb8j0zQFZCmdehVs1Okmhb0MMeta?.name,
    path: "/owner-info",
    component: () => import("/frontend/pages/owner-info.vue"),
    children: [
  {
    name: "owner-info",
    path: "",
    meta: indexMkuEqFzZ_Dneco9iF6uaT9dVuvr7DSl9S58F1edS2MEMeta || {},
    component: () => import("/frontend/pages/owner-info/index.vue")
  },
  {
    name: "owner-info-owner-info-2",
    path: "owner-info-2",
    meta: owner_45info_452t0d6DctW10Z36TguO453eybyhfqm10qvqcE1rd_NunAMeta || {},
    component: () => import("/frontend/pages/owner-info/owner-info-2.vue")
  },
  {
    name: "owner-info-owner-info-3",
    path: "owner-info-3",
    meta: owner_45info_453qHICeLdqf7Bj2RS_45IaJrlwZa39BkhxZpliS9GNb2jFIMeta || {},
    component: () => import("/frontend/pages/owner-info/owner-info-3.vue")
  },
  {
    name: "owner-info-owner-info-4",
    path: "owner-info-4",
    meta: owner_45info_454Ra5IZ21TzD3Iekou4HQA9x5gaVJsxPy9XFmCA74torcMeta || {},
    component: () => import("/frontend/pages/owner-info/owner-info-4.vue")
  }
]
  },
  {
    name: "playground",
    path: "/playground",
    component: () => import("/frontend/pages/playground.vue")
  },
  {
    name: "resume-app",
    path: "/resume-app",
    meta: resume_45app3WeL6_45R977rvYa6rv228EYJimw0Abgo_45RPHYvbav9qwMeta || {},
    component: () => import("/frontend/pages/resume-app.vue")
  },
  {
    name: "waypoint-0",
    path: "/waypoint-0",
    meta: waypoint_450KCEiR0JV1gPMSXmyDdbmtyPE_45acKeqS9dl7bQ_0u8H0Meta || {},
    component: () => import("/frontend/pages/waypoint-0.vue")
  },
  {
    name: "waypoint-1",
    path: "/waypoint-1",
    meta: waypoint_451U9ucGsmoCchXKFaIKcU6OB_uWJdtL6tl2gQLpFWKApcMeta || {},
    component: () => import("/frontend/pages/waypoint-1.vue")
  },
  {
    name: "cookie-test",
    path: "/cookie-test",
    component: () => import("/frontend/pages/cookie-test.vue")
  },
  {
    name: "healthcheck",
    path: "/healthcheck",
    meta: healthcheckYQ8eo1fMo7prZ5ymNyJxt_wOdqKc85lsGcGdG4lNYNcMeta || {},
    component: () => import("/frontend/pages/healthcheck.vue")
  },
  {
    name: "login-error",
    path: "/login-error",
    meta: login_45errorywEx_45Wectovy61ydcmvxbJe2h13k2U5pUl6qTKwMq6IMeta || {},
    component: () => import("/frontend/pages/login-error.vue")
  },
  {
    name: "multiselect",
    path: "/multiselect",
    component: () => import("/frontend/pages/multiselect.vue")
  },
  {
    name: "heloc-option",
    path: "/heloc-option",
    meta: heloc_45optiontYr1MajY5lmQUHYs_dTDmpJbWyXmcYrXqt5NOW9J4PwMeta || {},
    component: () => import("/frontend/pages/heloc-option.vue")
  },
  {
    name: "under-review",
    path: "/under-review",
    meta: under_45reviewX1vnZZUugn_Jqjx9ZbBszgUBATZ54myq5RYsuwAcqdUMeta || {},
    component: () => import("/frontend/pages/under-review.vue")
  },
  {
    name: updated_45infooP5phe2d7oXgGEjSgu9FeVHdWi_45L8MCxARgS86xA81MMeta?.name,
    path: "/updated-info",
    component: () => import("/frontend/pages/updated-info.vue"),
    children: [
  {
    name: "updated-info",
    path: "",
    meta: index_mEV_45Xcs3qrBsFmPl_45sTn7LiLmsJ72MsCUNna8pT4WIMeta || {},
    component: () => import("/frontend/pages/updated-info/index.vue")
  }
]
  },
  {
    name: "upload",
    path: "/upload",
    component: () => import("/frontend/pages/upload/index.vue")
  },
  {
    name: business_45infobAMqXNIzhfTMl1fTVys2h_x8nFUpRQ_45LQx2fQjD6vK8Meta?.name,
    path: "/business-info",
    meta: business_45infobAMqXNIzhfTMl1fTVys2h_x8nFUpRQ_45LQx2fQjD6vK8Meta || {},
    component: () => import("/frontend/pages/business-info.vue"),
    children: [
  {
    name: "business-info",
    path: "",
    meta: indexQQOgBfa0k5tmB8HAJsEgGdkTRf1icr0J4_pFDVkglxoMeta || {},
    component: () => import("/frontend/pages/business-info/index.vue")
  },
  {
    name: "business-info-business-info-2",
    path: "business-info-2",
    meta: business_45info_452k32xGOtCRIHiiPlUoTLvAT3ZcElNRUibjt_45qx0JdryQMeta || {},
    component: () => import("/frontend/pages/business-info/business-info-2.vue")
  },
  {
    name: "business-info-business-info-3",
    path: "business-info-3",
    meta: business_45info_453UZTY9_mHSqpp_45VbbuVg0P85B41wn88O6f5F07RyKtQMMeta || {},
    component: () => import("/frontend/pages/business-info/business-info-3.vue")
  }
]
  },
  {
    name: "renewal",
    path: "/renewal",
    meta: indexrqnHW0yOU_457uvpQ7M_45aIzAifYnDtXNiu800Op2hJHMoMeta || {},
    component: () => import("/frontend/pages/renewal/index.vue")
  },
  {
    name: "upload-manual",
    path: "/upload/manual",
    component: () => import("/frontend/pages/upload/manual.vue")
  },
  {
    name: basic_45info_45newCRPiaJc8hZRScMbKNnacpaVRAhZSdf2nEEwL7GvJIQ8Meta?.name,
    path: "/basic-info-new",
    meta: basic_45info_45newCRPiaJc8hZRScMbKNnacpaVRAhZSdf2nEEwL7GvJIQ8Meta || {},
    component: () => import("/frontend/pages/basic-info-new.vue"),
    children: [
  {
    name: "basic-info-new",
    path: "",
    meta: indexOOU7MfCzXPxQiH8lz7NBlSbK0mSNI5Fltp7bXSqO9XcMeta || {},
    component: () => import("/frontend/pages/basic-info-new/index.vue")
  },
  {
    name: "basic-info-new-_question",
    path: "_question",
    component: () => import("/frontend/pages/basic-info-new/_question.vue")
  }
]
  },
  {
    name: "embedded",
    path: "/embedded",
    meta: index4I7Xz_45D8zqxmujKwPVmZ7ETZUna_vF2DIz5xuutjSg8Meta || {},
    component: () => import("/frontend/pages/embedded/index.vue")
  },
  {
    name: "identity",
    path: "/identity",
    meta: indexm65eO2jflY0sicSPHN9nOTgPVsDfSA49ZfsDRowFJYgMeta || {},
    component: () => import("/frontend/pages/identity/index.vue")
  },
  {
    name: "renewal-submit",
    path: "/renewal/submit",
    meta: submitm0JgYN6OmbMWsyY5fG0Qyt_cHVQZPPWzFJ1v7VYMj8cMeta || {},
    component: () => import("/frontend/pages/renewal/submit.vue")
  },
  {
    name: portalWete5wHUFO3fpdmya0DGomNS3tLTHHPfMbnllH9XehMMeta?.name,
    path: "/embedded/portal",
    meta: portalWete5wHUFO3fpdmya0DGomNS3tLTHHPfMbnllH9XehMMeta || {},
    component: () => import("/frontend/pages/embedded/portal.vue"),
    children: [
  {
    name: "embedded-portal-sync",
    path: "sync",
    component: () => import("/frontend/pages/embedded/portal/sync.vue")
  },
  {
    name: "embedded-portal",
    path: "",
    component: () => import("/frontend/pages/embedded/portal/index.vue")
  },
  {
    name: "embedded-portal-results",
    path: "results",
    component: () => import("/frontend/pages/embedded/portal/results.vue")
  },
  {
    name: "embedded-portal-accounts",
    path: "accounts",
    component: () => import("/frontend/pages/embedded/portal/accounts.vue")
  },
  {
    name: "embedded-portal-dashboard",
    path: "dashboard",
    component: () => import("/frontend/pages/embedded/portal/dashboard.vue")
  },
  {
    name: "embedded-portal-documents",
    path: "documents",
    component: () => import("/frontend/pages/embedded/portal/documents.vue")
  },
  {
    name: "embedded-portal-sync-error",
    path: "sync-error",
    component: () => import("/frontend/pages/embedded/portal/sync-error.vue")
  },
  {
    name: "embedded-portal-statement-error",
    path: "statement-error",
    component: () => import("/frontend/pages/embedded/portal/statement-error.vue")
  },
  {
    name: "embedded-portal-options-optionId",
    path: "options/:optionId()",
    component: () => import("/frontend/pages/embedded/portal/options/[optionId].vue")
  }
]
  },
  {
    name: "embedded-submit",
    path: "/embedded/submit",
    meta: submitzHiRNnOzmCNa0dY_tzpZFFfnuWw6HcWbAtlI9eyjdrsMeta || {},
    component: () => import("/frontend/pages/embedded/submit.vue")
  },
  {
    name: "guest-bad-token",
    path: "/guest/bad-token",
    meta: bad_45token5rdn9LwCt_45ZISZiJarknZrdUW4hqgT9RHcesivTEVwcMeta || {},
    component: () => import("/frontend/pages/guest/bad-token.vue")
  },
  {
    name: "sba-tax-returns",
    path: "/sba/tax-returns",
    meta: tax_45returnsuQV_vSa2k1rBI7gPixkxdK6ClOFjJuICVZTLZjO2VMIMeta || {},
    component: () => import("/frontend/pages/sba/tax-returns.vue")
  },
  {
    name: "upload-finicity",
    path: "/upload/finicity",
    component: () => import("/frontend/pages/upload/finicity.vue")
  },
  {
    name: "upload-requests",
    path: "/upload/requests",
    component: () => import("/frontend/pages/upload/requests.vue")
  },
  {
    name: "sba-balance-sheet",
    path: "/sba/balance-sheet",
    meta: balance_45sheetssfD_9yid2Se7xBE1bYNWLx20zd0dSoQ_45fND_v_45piY4Meta || {},
    component: () => import("/frontend/pages/sba/balance-sheet.vue")
  },
  {
    name: "sba-debt-schedule",
    path: "/sba/debt-schedule",
    meta: debt_45scheduleuELk_PIj7MsdVRITsa_45c_45YRO9odk56TvpHQ5gy6pd6gMeta || {},
    component: () => import("/frontend/pages/sba/debt-schedule.vue")
  },
  {
    name: "credit-card-widget",
    path: "/credit-card-widget",
    meta: credit_45card_45widgetjugnDK4_453ljatQwB7Tc8W5POnOdaY_I3mkGU_5WtLsYMeta || {},
    component: () => import("/frontend/pages/credit-card-widget.vue")
  },
  {
    name: documents1WkmfaNAVpXwtwE903P6yptT6VobyqhPtZiWv9FihvIMeta?.name,
    path: "/embedded/documents",
    meta: documents1WkmfaNAVpXwtwE903P6yptT6VobyqhPtZiWv9FihvIMeta || {},
    component: () => import("/frontend/pages/embedded/documents.vue"),
    children: [
  {
    name: "embedded-documents-sync",
    path: "sync",
    component: () => import("/frontend/pages/embedded/documents/sync.vue")
  },
  {
    name: "embedded-documents",
    path: "",
    component: () => import("/frontend/pages/embedded/documents/index.vue")
  },
  {
    name: "embedded-documents-manual",
    path: "manual",
    component: () => import("/frontend/pages/embedded/documents/manual.vue")
  },
  {
    name: "embedded-documents-results",
    path: "results",
    component: () => import("/frontend/pages/embedded/documents/results.vue")
  },
  {
    name: "embedded-documents-accounts",
    path: "accounts",
    component: () => import("/frontend/pages/embedded/documents/accounts.vue")
  },
  {
    name: "embedded-documents-sync-error",
    path: "sync-error",
    component: () => import("/frontend/pages/embedded/documents/sync-error.vue")
  },
  {
    name: "embedded-documents-statement-error",
    path: "statement-error",
    component: () => import("/frontend/pages/embedded/documents/statement-error.vue")
  }
]
  },
  {
    name: "sba-complete",
    path: "/sba-complete",
    meta: indexXmAxiRTZJwBadAkVW6SnJ_452X7zWLDnjiPzTzWarV_BIMeta || {},
    component: () => import("/frontend/pages/sba-complete/index.vue")
  },
  {
    name: "embedded-resume-app",
    path: "/embedded/resume-app",
    meta: resume_45appZgdNXJ5t6AmRniERr1Y3WZuVtRql3Bmemu756zhKHYYMeta || {},
    component: () => import("/frontend/pages/embedded/resume-app.vue")
  },
  {
    name: "funding-needs",
    path: "/funding-needs",
    meta: indexxrEiTOHYVhq_6wAOx_45ElKdFIuJTMJ43bf8ul2T4ruS0Meta || {},
    component: () => import("/frontend/pages/funding-needs/index.vue")
  },
  {
    name: "sba-profit-and-loss",
    path: "/sba/profit-and-loss",
    meta: profit_45and_45lossgEDfcgfgf9_45P62J_SO6VS9FQyfv_45E1KtWxWrUVBLLiMMeta || {},
    component: () => import("/frontend/pages/sba/profit-and-loss.vue")
  },
  {
    name: "app-complete-landing",
    path: "/app-complete-landing",
    meta: app_45complete_45landingCE4H7t8WemuUjZ0o5B8UHCvKeN7CwmkjeF16MKJuP68Meta || {},
    component: () => import("/frontend/pages/app-complete-landing.vue")
  },
  {
    name: "identity-component",
    path: "/identity/:component()",
    meta: _91component_93GgQVhfAEH7Yk6AisKJf7YsUZhR5bqTWc24V1tHl3ORUMeta || {},
    component: () => import("/frontend/pages/identity/[component].vue")
  },
  {
    name: "redirect-from-lendio",
    path: "/redirect-from-lendio",
    component: () => import("/frontend/pages/redirect-from-lendio.vue")
  },
  {
    name: "advertiser-disclosure",
    path: "/advertiser-disclosure",
    component: () => import("/frontend/pages/advertiser-disclosure.vue")
  },
  {
    name: "renewal-business-info",
    path: "/renewal/business-info",
    meta: business_45infoaS3n8iQDbaQqwYZxwYlHe6ufY747mzrFz_jdecsRdVUMeta || {},
    component: () => import("/frontend/pages/renewal/business-info.vue")
  },
  {
    name: "identifier-app",
    path: "/:identifier()-app",
    component: () => import("/frontend/pages/[identifier]-app/index.vue")
  },
  {
    name: "renewal-documents",
    path: "/renewal/documents",
    meta: indexf74NMKswyG2liR_7RWe0f1VMWENO9Z2f_45J_45tKBnmt2cMeta || {},
    component: () => import("/frontend/pages/renewal/documents/index.vue")
  },
  {
    name: "renewal-documents-manual",
    path: "/renewal/documents/manual",
    meta: manualckDQlayw_TkpIGosh11XfPy94d5pTGt1azA3_45VU21aUMeta || {},
    component: () => import("/frontend/pages/renewal/documents/manual.vue")
  },
  {
    name: "sba-debt-schedule-upload",
    path: "/sba/debt-schedule-upload",
    meta: debt_45schedule_45uploadoUZDAZP0i4j0tf_3wJp4dQ9sG0Z75BYXAezWBahqFvEMeta || {},
    component: () => import("/frontend/pages/sba/debt-schedule-upload.vue")
  },
  {
    name: "identifier-app-slug",
    path: "/:identifier()-app/:slug?",
    meta: _91_91slug_93_93xqO3Du7v7S2nuqxXR0wRw8Fr9IgjyBxlsdP_458knq848Meta || {},
    component: () => import("/frontend/pages/[identifier]-app/[[slug]].vue")
  },
  {
    name: "intelligent-lending",
    path: "/intelligent-lending",
    meta: indexRhn9u_yrzTFVb5OkVPFTCgiFtXGy8RJXbcjEmKfxfxsMeta || {},
    component: () => import("/frontend/pages/intelligent-lending/index.vue")
  },
  {
    name: "sba-complete-portal",
    path: "/sba-complete/portal",
    meta: indexGfPncHXPKwssAmJzzS3iEQXS_S4O5kYdve17A1Jcz68Meta || {},
    component: () => import("/frontend/pages/sba-complete/portal/index.vue")
  },
  {
    name: portal1DyOuxZ4iUzdcxGUM_ztsa6HqRAjhL22Ik7qjCOT1LMMeta?.name,
    path: "/intelligent-lending/portal",
    meta: portal1DyOuxZ4iUzdcxGUM_ztsa6HqRAjhL22Ik7qjCOT1LMMeta || {},
    component: () => import("/frontend/pages/intelligent-lending/portal.vue"),
    children: [
  {
    name: "intelligent-lending-portal",
    path: "",
    component: () => import("/frontend/pages/intelligent-lending/portal/index.vue")
  },
  {
    name: "intelligent-lending-portal-dashboard",
    path: "dashboard",
    meta: dashboardXgPc7JSFTNiz6LMPJXCUQ9vkuWNjlDx_CNIVjC9yrOsMeta || {},
    component: () => import("/frontend/pages/intelligent-lending/portal/dashboard.vue")
  },
  {
    name: "intelligent-lending-portal-documents",
    path: "documents",
    component: () => import("/frontend/pages/intelligent-lending/portal/documents.vue")
  },
  {
    name: "intelligent-lending-portal-options-optionId",
    path: "options/:optionId()",
    component: () => import("/frontend/pages/intelligent-lending/portal/options/[optionId].vue")
  }
]
  },
  {
    name: "renewal-credit-check",
    path: "/renewal/credit-check",
    meta: indexmoCHtu7EVEVx30oet2PmzdIOiDoBRTDgqxm6xOdmMlwMeta || {},
    component: () => import("/frontend/pages/renewal/credit-check/index.vue")
  },
  {
    name: "renewal-credit-check-review",
    path: "/renewal/credit-check/review",
    meta: reviewhn1NZp0DVD_p3inlF9c2KdNd_45vHP9QrvgV88BEGtB30Meta || {},
    component: () => import("/frontend/pages/renewal/credit-check/review.vue")
  },
  {
    name: "guest-additional-owner",
    path: "/guest/additional-owner",
    meta: index21fxnIBIXWZslO_45dfbSqzAeJlKfeXluDiMMjGgQ96QkMeta || {},
    component: () => import("/frontend/pages/guest/additional-owner/index.vue")
  },
  {
    name: "renewal-new-loan-requirements",
    path: "/renewal/new-loan-requirements",
    meta: new_45loan_45requirementsg92mo0DE7_47jKHbiTFFhpwnKbYzigqRXLJ4s8gtMmwMeta || {},
    component: () => import("/frontend/pages/renewal/new-loan-requirements.vue")
  },
  {
    name: "sba-complete-portal-documents",
    path: "/sba-complete/portal/documents",
    meta: documentsnhEgr7Ue_45ldgcoDVW6YrcRoWQ9eCKDBInAv9MdOWcBEMeta || {},
    component: () => import("/frontend/pages/sba-complete/portal/documents.vue")
  },
  {
    name: "embedded-identifier-app",
    path: "/embedded/:identifier()-app",
    component: () => import("/frontend/pages/embedded/[identifier]-app/index.vue")
  },
  {
    name: "application-moduleIdentifier",
    path: "/application/:moduleIdentifier?",
    meta: _91_91moduleIdentifier_93_93VA9i4xuXPSVJ3NDnibHdU3u4gNRMZBFH7iw5crnjD2QMeta || {},
    component: () => import("/frontend/pages/application/[[moduleIdentifier]].vue")
  },
  {
    name: "document-upload-request-authType",
    path: "/document-upload-request/:authType()",
    meta: _91authType_93jQqxlLujyMmIPuW1YgqP8us1sV5qcjBJCkuW2iaubMYMeta || {},
    component: () => import("/frontend/pages/document-upload-request/[authType].vue")
  },
  {
    name: "embedded-identifier-app-slug",
    path: "/embedded/:identifier()-app/:slug?",
    meta: _91_91slug_93_93e4hab0weHUOjGVa40_45foByVrCAyTUjx_l9uywzHuKvkMeta || {},
    component: () => import("/frontend/pages/embedded/[identifier]-app/[[slug]].vue")
  },
  {
    name: "guest-additional-owner-post-offer-docs",
    path: "/guest/additional-owner/post-offer-docs",
    meta: post_45offer_45docscvswxhwYCGH0UcWZWclmsjkNl1fUncJMKw1Rp6lY5jsMeta || {},
    component: () => import("/frontend/pages/guest/additional-owner/post-offer-docs.vue")
  },
  {
    name: "embedded-document-upload-request-authType",
    path: "/embedded/document-upload-request/:authType()",
    meta: _91authType_93YUsLfn2aQMM2me8ti9Qaj9uBy1PLcILPBPnwhvtHctoMeta || {},
    component: () => import("/frontend/pages/embedded/document-upload-request/[authType].vue")
  },
  {
    name: "document-upload-request-invite-expired",
    path: "/document-upload-request/invite-expired",
    meta: indexY_KWRMLPxuopwYEFVmt74OGdxaBcccnrkq8fPzMNzgsMeta || {},
    component: () => import("/frontend/pages/document-upload-request/invite-expired/index.vue")
  },
  {
    name: "embedded-document-upload-request-invite-expired",
    path: "/embedded/document-upload-request/invite-expired",
    meta: indexJhK3HqYQB8RFnu9bMa_thV32UcQ7uAyoFzUDA99avXoMeta || {},
    component: () => import("/frontend/pages/embedded/document-upload-request/invite-expired/index.vue")
  },
  {
    name: "sba-complete-basic-info",
    path: "/sba-complete/basic-info",
    meta: basic_45infowNHn_450Pa7TqG_3t2zL5tUc1i9qgM9Ob9VhBzN9BF3DgMeta || {},
    component: () => import("~/pages/basic-info.vue")
  },
  {
    name: owner_45infon2CGFN5bZlpexaQz005VuiL2_45aIznDSiaTh9q1lYAvQMeta?.name,
    path: "/sba-complete/owner-info",
    component: () => import("~/pages/owner-info.vue"),
    children: [
  {
    name: "sba-complete-owner-info",
    path: "",
    meta: indexK64C_45O2mp4GqPo3E4O1hTQG0wpwozxGgfZjA345GDD0Meta || {},
    component: () => import("~/pages/owner-info/index.vue")
  },
  {
    name: "sba-complete-owner-info-2",
    path: "owner-info-2",
    meta: owner_45info_452yz2cMWLJbp6fvZY254WruVkFPOVTu2wemo7KQX9rfHMMeta || {},
    component: () => import("~/pages/owner-info/owner-info-2.vue")
  },
  {
    name: "sba-complete-owner-info-3",
    path: "owner-info-3",
    meta: owner_45info_453T3TfkhNxxLejrxU9LrqVRKxcRYWkqrEh74TCU8RzXF0Meta || {},
    component: () => import("~/pages/owner-info/owner-info-3.vue")
  }
]
  },
  {
    name: business_45infoXDsz_45sSqy_4590EqfoL0D_5bql_45vaAec2h0mhCSkrQdIQMeta?.name,
    path: "/sba-complete/business-info",
    meta: business_45infoXDsz_45sSqy_4590EqfoL0D_5bql_45vaAec2h0mhCSkrQdIQMeta || {},
    component: () => import("~/pages/business-info.vue"),
    children: [
  {
    name: "sba-complete-business-info-1",
    path: "",
    meta: indexKoNmPaOPj9fO_45AVi0r0_45pjw3cnfJWWSOSUkdKUzO6NEMeta || {},
    component: () => import("~/pages/business-info/index.vue")
  },
  {
    name: "sba-complete-business-info-2",
    path: "business-info-2",
    meta: business_45info_4527psyUxUEEuQINe7f9FVNH04FkFLIdOOWutgaU_gfDqQMeta || {},
    component: () => import("~/pages/business-info/business-info-2.vue")
  },
  {
    name: "sba-complete-business-info-3",
    path: "business-info-3",
    meta: business_45info_453MdB7j_hMLF_45rxUJ2sp99_45oMHfi5zq0ukMuYIv7QuCfoMeta || {},
    component: () => import("~/pages/business-info/business-info-3.vue")
  }
]
  },
  {
    name: documents7_DYPq8779fTX9Gn6aG9g5SzaBW_45x1PyD1UW_45Fcr_aYMeta?.name,
    path: "/sba-complete/documents",
    meta: documents7_DYPq8779fTX9Gn6aG9g5SzaBW_45x1PyD1UW_45Fcr_aYMeta || {},
    component: () => import("~/pages/documents.vue"),
    children: [
  {
    name: "sba-complete-bank-statements",
    path: "",
    meta: indexZ9aaVvuzpxfqSYY4hXdaXn8HVfLGTrDcS6Z5GMvx9_UMeta || {},
    component: () => import("~/pages/documents/index.vue")
  },
  {
    name: "sba-complete-bank-statements-accounts",
    path: "accounts",
    meta: accountsuBSOEx81DpVW9rl_RsyWufEG_45t2wq643omUIpaTDz7UMeta || {},
    component: () => import("~/pages/documents/accounts.vue")
  },
  {
    name: "sba-complete-bank-statements-manual",
    path: "manual",
    component: () => import("~/pages/documents/manual.vue")
  },
  {
    name: "sba-complete-bank-statements-results",
    path: "results",
    meta: resultsaPXJgf4mfFB8p9abOVmX1yxGTtaqRqa4ENu1qdY0nkoMeta || {},
    component: () => import("~/pages/documents/results.vue")
  },
  {
    name: "sba-complete-bank-statements-statement-error",
    path: "statement-error",
    meta: statement_45errorzP33rheL2DsxelLd0YM_45V4YgsqbeAsD3DZC4gC9OBe8Meta || {},
    component: () => import("~/pages/documents/statement-error.vue")
  },
  {
    name: "sba-complete-bank-statements-sync-error",
    path: "sync-error",
    meta: sync_45errorx_45VB5eaPM3SqV5sqPrckOPF0h1NQ9AcdgqnEwVnQo9oMeta || {},
    component: () => import("~/pages/documents/sync-error.vue")
  },
  {
    name: "sba-complete-bank-statements-sync",
    path: "sync",
    meta: syncpxmBItkpUdp2ZTELUumD_Wax5yb5tI57CyYKetoSaQcMeta || {},
    component: () => import("~/pages/documents/sync.vue")
  }
]
  },
  {
    name: "sba-complete-tax-returns",
    path: "/sba-complete/tax-returns",
    meta: tax_45returns_45uBs0vuVn41C_xAe4hZXYXxRuIBwLINWylfg_450npgiIMeta || {},
    component: () => import("~/pages/sba/tax-returns.vue")
  },
  {
    name: "sba-complete-debt-schedule",
    path: "/sba-complete/debt-schedule",
    meta: debt_45scheduleM5qmco6kmOe6xwg7lTdi4LNQ1zGYRA6OVC5_dcv3aq4Meta || {},
    component: () => import("~/pages/sba/debt-schedule.vue")
  },
  {
    name: "sba-complete-debt-schedule-upload",
    path: "/sba-complete/debt-schedule-upload",
    meta: debt_45schedule_45uploadN03F58eiN8Tz9nEWThiuRD7g7zJzO5Lm711cwskCDCIMeta || {},
    component: () => import("~/pages/sba/debt-schedule-upload.vue")
  },
  {
    name: "sba-complete-profit-and-loss",
    path: "/sba-complete/profit-and-loss",
    meta: profit_45and_45lossmpiDu4cis9pJC87J55i7ipfGZIV0hkrVfoFBLRWPnDwMeta || {},
    component: () => import("~/pages/sba/profit-and-loss.vue")
  },
  {
    name: "sba-complete-balance-sheet",
    path: "/sba-complete/balance-sheet",
    meta: balance_45sheetU4IaDaZIQKNlnBfUXmSbLdb2GPwsr6q50MMEm7xlqVIMeta || {},
    component: () => import("~/pages/sba/balance-sheet.vue")
  },
  {
    name: "sba-complete-submit",
    path: "/sba-complete/submit",
    meta: submitFLwjJ08Bcd41JWktkSWQjUpOoWjBAK8XJ_LyBPW3YJMMeta || {},
    component: () => import("~/pages/embedded/submit.vue")
  }
]